import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonType } from 'src/model/enum/enums';
import { discoverActions } from 'src/store/slices/discoverSlice';
import { RootState } from '../../store/store';

export const useDiscover = () => {
    const dispatch = useDispatch();
    const ac = bindActionCreators(discoverActions, dispatch);
    const { moveNext, shouldLearnCount, alreadyKnewCount, lastButtonType, updatedRange } = useSelector((state: RootState) => state.discover);

    return {
        moveNext: () => moveNext?.(),
        setMoveNext: (fn: () => void) => ac.setMoveNext(fn),
        shouldLearnCount,
        setShouldLearnCount: (count: number) => ac.setShouldLearnCount(count),
        alreadyKnewCount,
        setAlreadyKnewCount: (count: number) => ac.setAlreadyKnewCount(count),
        lastButtonType,
        setLastButtonType: (type: ButtonType | null) => ac.setLastButtonType(type),
        updatedRange,
        setUpdatedRange: (range: number) => ac.setUpdatedRange(range)
    };
};
